import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    formBody: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%'
    },
    submitSection: {
        display: 'flex',
        flexDirection: 'column',
        '& > button, & > a': {
            marginTop: theme.spacing(4)
        }
    },
    acceptTooltip: {
        padding: theme.spacing(4)
    },
    legalAgeSection: {
        marginBottom: theme.spacing(4),
        flex: 1
    }
}));

export default useStyles;
